import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import { Text, Space, Divider } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';

export const PreviewResumeExperienceItem = memo(
  ({ item: { id, company = '', position = '', start, end, description } }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { styles, colors } = useStyle();
    const { dictionary } = useLocale();

    const periodText = [...(start ? [start] : []), ...(end ? [end] : [])].join(
      ' - '
    );

    const limitButtonIsvisible = !!description;

    return (
      <View style={[styles.container]}>
        <Text style={styles.text}>{company}</Text>
        <Space size={8} />
        <Text style={styles.subText}>{position}</Text>
        <Text style={styles.subText}>{periodText}</Text>
        <Space size={8} />
        {isExpanded && (
          <Text style={styles.descriptionText}>{description}</Text>
        )}
        <Space size={8} />
        {limitButtonIsvisible && (
          <>
            <Divider color={colors.background} />
            <Button
              variant="transparent"
              title={isExpanded ? dictionary.less : dictionary.more}
              textStyle={styles.buttonTextStyle}
              onPress={() => setIsExpanded((prev) => !prev)}
            />
          </>
        )}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    backgroundColor: colors.cardBackground,
    padding: 16,
    borderRadius: 10,
    paddingBottom: 0,
  },
  text: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
  },
  subText: {
    fontSize: 14,
    color: colors.subtitle,
  },
  buttonTextStyle: {
    color: colors.primary,
  },
  descriptionText: {
    color: colors.description,
  },
}));
